import type { OrganizationFrame } from "@kontextwerk/control-web-client"
import type { PageTabWithId } from "@kontextwerk/web-sdk/core/navigation/viewNavigation"
import type { PermissionState } from "../../../_shared/_logic/permissions-model"
import { resolveHomeDashboardAccess } from "./_shared/_logic/home-dashboard"

type OverviewFrameContext = import("../../context").OrgaViewFrameContext

export type PageContext = {
  permissions: PermissionState
  organization: OrganizationFrame | null
}

const canViewAnalytics = (permissions: PermissionState) =>
  permissions.allows("core.analytics", "view")

export const canViewPlanningStatistics = (permissions: PermissionState) =>
  resolveHomeDashboardAccess(permissions).canViewScheduling

export const getTabs = (ctx: OverviewFrameContext): PageTabWithId[] => {
  const tabs: PageTabWithId[] = [{ id: "home", title: "Startseite" }]
  const analyticsAllowed = ctx.tariffCapabilities.hasAnalytics && canViewAnalytics(ctx.permissions)

  if (analyticsAllowed) {
    tabs.push({ id: "sessions", title: "Sessions" })
  }

  // Keep the existing analytics tab order and its numeric deep links unchanged.
  if (analyticsAllowed || canViewPlanningStatistics(ctx.permissions)) {
    tabs.push({ id: "statistics", title: "Statistiken" })
  }

  return tabs
}

export type { OverviewFrameContext }
export { canViewAnalytics }
